export const enum VirtualFileType {
  GENERATED_FILE = "file",
  MULTI_PAGE_PDF = "pdf",
  REMOTE_FILE = "url",
  SINGLE_PAGE_IMAGE = "img",
  SINGLE_PAGE_PDF = "page",
  ZIP_FILE = "zip",
}
